module.exports = __webpack_public_path__ + "static/media/team3.0e0ea9e9.jpg";